"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var prepareShadowSizeFor = function (Tokens, identifier) {
    var shadowHOffset = Tokens["SizeShadow" + identifier + "HOffset"];
    var shadowVOffset = Tokens["SizeShadow" + identifier + "VOffset"];
    var shadowBlurRadius = Tokens["SizeShadow" + identifier + "BlurRadius"];
    var shadowSpreadRadius = Tokens["SizeShadow" + identifier + "SpreadRadius"];
    return shadowHOffset + " " + shadowVOffset + " " + shadowBlurRadius + " " + shadowSpreadRadius;
};
exports.default = (function (Tokens) {
    return __assign(__assign({}, Tokens), { SizeShadowButtonActive: prepareShadowSizeFor(Tokens, 'ButtonActive'), SizeShadowButtonFloating: prepareShadowSizeFor(Tokens, 'ButtonFloating'), SizeShadowCheckbox: prepareShadowSizeFor(Tokens, 'Checkbox'), SizeShadowRadio: prepareShadowSizeFor(Tokens, 'Radio'), SizeShadowDialog: prepareShadowSizeFor(Tokens, 'Dialog'), SizeShadowSwitchCircleBase: prepareShadowSizeFor(Tokens, 'SwitchCircleBase'), SizeShadowSwitchCircleHover: prepareShadowSizeFor(Tokens, 'SwitchCircleHover'), SizeShadowToastBase: prepareShadowSizeFor(Tokens, 'ToastBase'), SizeShadowTooltipText: prepareShadowSizeFor(Tokens, 'TooltipText'), SizeShadowTooltipDialog: prepareShadowSizeFor(Tokens, 'TooltipDialog'), SizeShadowInputActive: prepareShadowSizeFor(Tokens, 'InputActive'), zIndex: {
            default: 0,
            bottomLayer: -1,
            topLayer: 9999
        }, ColorIconRatingChipBase: '#FFB60F' });
});
//# sourceMappingURL=prepareTheme.js.map